import React from 'react';
import ReactDOM from 'react-dom';
import {ShowInternalWidget} from '../common/main.jsx';
import { getSupportRequestUrl, isHpUser } from "../common/utils.js";
import { ProfileIcon, NotificationIcon, SubscribeIcon, NewsIcon, SearchIcon, ChatbotSandy} from "./icons.jsx";
import { Chatbot, MaintMsgModal } from '../common/components.jsx';

var _wikiUrl = "https://oss-wiki.hpcloud.hp.com/";

export function showInitialLoadError(activeTab, errMsg, targetTo) {
  ReactDOM.render(
    <div>
      <OSSMenu active={activeTab} />
      <div id="defaultErrorPaneText" className="alert alert-danger errorPaneWidget2" role="alert">
         <span className="alert-error">{errMsg}</span>
         <div>Note: Please use the above error message/hash to raise support ticket.</div>
      </div>
    </div>,
    document.getElementById(targetTo)
  );
};




if (typeof window === 'undefined') {

  function createCookie(url, tenant){

    const withoutProtocol = url.replace(/^https:\/\//, '');
    const match = withoutProtocol.match(/^([^.]+)/);

    var layer; 

    switch (match[0]) {
      case 'oss-dev':
        layer = "DEV";
        break;
      case 'oss-tst':
        layer = "TST";
        break;
      case 'oss-itg':
        layer = "ITG";
        break;
      case 'oss-stg':
        layer = "STG";
        break;
      case 'oss-qa':
        layer = "QA";
        break;
      default:
        layer = "";
    }

    return match ? "ossForcedTenant" + layer + "=" + tenant +  "; path=/; max-age=315360000" : null;

  }

  function SwitchToHPE() {
    document.cookie = createCookie(document.URL, "HPE");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  function SwitchToHPI() {
    document.cookie = createCookie(document.URL, "HPI");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  function SwitchToHPIFEDLLC() {
    document.cookie = createCookie(document.URL, "HPIFEDLLC");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  function SwitchToHPSTORE() {
    document.cookie = createCookie(document.URL, "HPSTORE");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  function SwitchToHPICS() {
    document.cookie = createCookie(document.URL, "HPICS");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

} else {

  window.createCookie = function (url, tenant) {

    const withoutProtocol = url.replace(/^https:\/\//, '');
    const match = withoutProtocol.match(/^([^.]+)/);

    var layer; 

    switch (match[0]) {
      case 'oss-dev':
        layer = "DEV";
        break;
      case 'oss-tst':
        layer = "TST";
        break;
      case 'oss-itg':
        layer = "ITG";
        break;
      case 'oss-stg':
        layer = "STG";
        break;
      case 'oss-qa':
        layer = "QA";
        break;
      default:
        layer = "";
    }

    return match ? "ossForcedTenant" + layer + "=" + tenant +  "; path=/; max-age=315360000" : null;

  }

  window.SwitchToHPE = function () {
    document.cookie = createCookie(document.URL, "HPE");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  window.SwitchToHPI = function() {
    document.cookie = createCookie(document.URL, "HPI");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  window.SwitchToHPIFEDLLC = function() {
    document.cookie = createCookie(document.URL, "HPIFEDLLC");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

  window.SwitchToHPSTORE = function() {
    document.cookie = createCookie(document.URL, "HPSTORE");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }
  window.SwitchToHPICS = function() {
    document.cookie = createCookie(document.URL, "HPICS");
    if (document.location.pathname.match("OrderStatusViewer.html") || document.location.pathname.match("shipment.html")) {
      location.assign(window.location.origin)
    } else {
      location.reload();
    }
  }

}

window.HandleShowOrder = function( e, legacy_order_no ) {
  console.log('standalone handleShowOrder:',legacy_order_no, e);
  e.preventDefault();
  e.stopPropagation();
  var self = this;
  var oLog = {lprms:{}};
  var pathname = window.location.pathname;
  var filename = pathname.substring(pathname.lastIndexOf('/')+1);
  if (e.currentTarget != undefined) {
    window.legacystate.logParams.e = "BMT_Widget_Redirect";
    oLog['lprms'] = window.legacystate.logParams;
    ShowInternalWidget('drilldown', legacy_order_no);
    //UserSettings.update('bm.lprms', oLog, (function(){ShowInternalWidget('drilldown', legacy_order_no)})(self));
    //UserSettings.set('bm.lprms', window.legacystate.logParams);
  } else {
    oLog['lprms'] = "TopBar_Widget_Redirect";
    ShowInternalWidget('TopBar', legacy_order_no);
    //UserSettings.update(filename + ".lprms", oLog, (function(){ShowInternalWidget('TopBar', legacy_order_no)})(self));
    //UserSettings.set(filename + ".lprms", "TopBar_Widget_Redirect");
  }
  return true;
};



//----------------------------------------------------------------------------
//  OSS top menu
//
//----------------------------------------------------------------------------
export class OSSMenu extends React.Component {

  handleLaunch() {


  }

  constructor(props){
    super(props);
    this.state={
    groupData : [],
    displayGroupData : [],
    notificationData : [],
    notificationModelView: false,
    supportRequestUrl: ''
    }
    this.displayGroup = this.displayGroup.bind(this);
    this.downloadUserSettings = this.downloadUserSettings.bind(this);
    this.getNotification = this.getNotification.bind(this);
    this.handleNotificationModel = this.handleNotificationModel.bind(this);
    this.handleUnSubscribe = this.handleUnSubscribe.bind(this);
    this.handleOrderLink = this.handleOrderLink.bind(this);
  }

  downloadUserSettings() {
    var today = new Date();
    var a = document.createElement('a');
    var mimeType = '"application/json';
    var fileName = 'OSS_User_Settings_' + UserSettings.user_id + '_' + today.getTime() + ".ust";
    var fileContent = JSON.stringify(UserSettings.val, null, '  ');

    if (navigator.msSaveBlob) { // IE10
      return navigator.msSaveBlob(new Blob([fileContent], { type: mimeType }), fileName);

    } else if ('download' in a) { //html5 A[download]
      a.href = 'data:' + mimeType + ',' + encodeURIComponent(fileContent);
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return true;

    } else { //do iframe dataURL download (old ch+FF):
      var f = document.createElement('iframe');
      document.body.appendChild(f);
      f.src = 'data:' + mimeType + ',' + encodeURIComponent(fileContent);
      setTimeout(function() {
        document.body.removeChild(f);
      }, 333);
      return true;
    }
  }

  displayGroup(){
    GET('/os/ossui/v1/in/cache/GroupDisplay', '', response => {
      const groupData = []; 
      const  displayGroupData = [];
      var level_value = 0;
      var tenant = UserSettings.tenant;  
      //console.log("ANB check active tab :"+ this.props.active);
      if(this.props.active == 'expert')
        level_value = 200; 
      if(this.props.active == 'backlog')
        level_value = 200; 
      if(this.props.active == 'tools')
        level_value = 400;
      if(this.props.active == 'help')
        level_value = 100;
      if(this.props.active == 'report')
        level_value = 200;
      if(this.props.active == 'ossprod')
        level_value = 200;
      //console.log("ANB:Checking Cache Array " + response);
      var userSettingsGroups = UserSettings.groups;
      //console.log("ANB:Checking User Array " + userSettingsGroups);

      for(var i=0; i < userSettingsGroups.length; i++) {
        if(response[userSettingsGroups[i]] != null){
          groupData.push(response[userSettingsGroups[i]]);
        }
        //console.log("ANB:Checking Group Data Array " + groupData);
      }
      for(var i = 0; i < groupData.length ; i++) {
        var flag = 0;
        if (tenant == "HPI"){
          if(groupData[i].tenant_value == "HPSTORE") {
            flag = 1;
          }
        } else 
        if (tenant == "HPSTORE") {
          if(groupData[i].tenant_value == "HPI"){
            flag = 1;
          }
        } else
        if (tenant = "HPIFEDLLC") {
          if((groupData[i].tenant_value == "ALL") || (groupData[i].acv_value == "AMS" && groupData[i].tenant_value == "HPI")){
            flag = 0;
          }
          else
            flag = 1;
        }

        var styles = {  padding: "5px 10px", 
                        fontSize: "13px", 
                        whiteSpace: "nowrap"
        } 
        if (flag != 0 && groupData[i].level < level_value) {
          styles.opacity = "0.25";
        }
        displayGroupData.push(<li key={'options-profile-grp_'+i} style={styles}>{groupData[i].display_name}</li>);
      }
      this.setState({groupData:groupData, displayGroupData:displayGroupData});
    });
  }

  componentDidMount() {
      var style = document.createElement("link");
      style.rel  = "stylesheet";
      style.type = "text/css";
      style.href = "/os/tiny_qtcui.css";
      style.id = 'newUIMenuStyle';
      document.body.appendChild(style);

      var qsrStyle = document.createElement("style");
      qsrStyle.innerHTML = ".autocomplete-items { left: 0ex; right: 1.5ex; }";
      document.body.appendChild(qsrStyle);

      var script = document.createElement("script");
      script.src = "/os/js/topMenuBar.js";
      document.body.appendChild(script);
      var script = document.createElement("script");
      script.src = "/lib/sorttable.js";
      document.body.appendChild(script);
      this.displayGroup();

      this.setState({
        supportRequestUrl: getSupportRequestUrl(UserSettings.config.links.SfdcWorkflowServiceUrl)
      })
      this.getNotification();
  }

  getNotification() {
    var self = this;
    GET("/os/ossui/v1/in/widgetExpert/getAllSubscriptions", '', function(res) {
       if(res){
         self.setState({ notificationData : res })
       }
    });
  }

  handleClearInput() {
      var inp = document.getElementById('quicksearch');
      inp.value= '';
      inp.focus();
      closeAllLists();
  }

  handleNotificationModel() {
   this.setState({ notificationModelView : !this.state.notificationModelView})
  }

  handleUnSubscribe(lon) {
    var param = {'lno': lon}

    fetch("/os/ossui/v1/in/widgetExpert/delSubscription", {
      method: "POST", 
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(param)
    })
      .then((res) => res.json())
      .then((res) => {
        this.getNotification();
      })
      .catch((err) => {
        alert("Error:", err);
      })
  }

  handleOrderLink(lon) {    
    LaunchPreferredViewer(lon)    
  }

  render() {

    if (window.UserSettings) {
       var UserSettings = window.UserSettings;         
    }

    var active = 'home';

    var tenant = 'HPI'

    var user_id = 'unknown';

    //GEGA in future (see below GEGA comment) this should be married.
    if (this.props.userSettings) {
      if (typeof this.props.userSettings.config.links.CorrelationServiceURL == "undefined") {
        var CorrelationServiceURL = '/';
      } else {
        var CorrelationServiceURL = this.props.userSettings.config.links.CorrelationServiceURL;
      }
    }

    if (typeof CorrelationServiceURL == "undefined") {

      if (typeof UserSettings.config.links.CorrelationServiceURL == "undefined") {
          var CorrelationServiceURL = '/';
      } else {
          var CorrelationServiceURL = UserSettings.config.links.CorrelationServiceURL;
      }

    }

    if (this.props.active) {
      active = this.props.active;
    }

    if (this.props.user_id) {
      user_id = this.props.user_id
    }
    if (this.props.tenant) {
      tenant = this.props.tenant
    }

    var newsSection = null;

    if (UserSettings && UserSettings.config.newsContent) {
        newsSection = UserSettings.config.newsContent;
    }

    var LayerName  = ""; // PROD
    if (UserSettings && UserSettings.config.layerName) {
        LayerName = UserSettings.config.layerName;
    }

    var downloadSettings = null;
    if(UserSettings) {
      downloadSettings = <li><a onClick={this.downloadUserSettings} style={{cursor:'pointer'}}>Download My Settings</a></li>
    }

    var notificationDetails = null;
    if(this.state.notificationData.length > 0) {
      $('#svgCircle').css('color','#0096d6');
      notificationDetails = (
        <div className="toggle-details" style={this.state.notificationModelView ? {'display':'none'} : {}}>
          <span className="title">My Subscriptions</span>
          <ul className="nlist">
           {
            this.state.notificationData.map((item, i) => {
              const lon = item.legacy_order_no;
              if(i < 5) {
                return (
                  <li key={i}>
                    <span className="widgetLink" onClick={() => this.handleOrderLink(lon)} style={{"width":"48%"}}>{item.order_no}</span> - <span style={{'display':'flex','alignItems':'center', 'height':'20px'}}>{item.order_overall_status} <span onClick={() => this.handleUnSubscribe(lon)} style={{ "color": "#00AA00"}}><SubscribeIcon style={{'marginTop':'4px'}} /></span>
                    </span>
                  </li>
                )
              }
            })
           }
          </ul>
          {this.state.notificationData.length > 4 ? <span className="view-link" onClick={this.handleNotificationModel}>View All</span> : null}
        </div>        
      )
    }

    var notificationModel = null;
    if(this.state.notificationModelView) {
      
      notificationModel = (
        <div id="emailSubscriptionContent" className="modal show" data-backdrop="static">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleNotificationModel}>x</button>
                <h3 className="modal-title" >My Subscriptions</h3>
              </div>
              <div className="modal-body" style={{'maxHeight': '400px', 'minHeight': '260px', 'overflow': 'auto'}}>
                <table style={{'width':'100%'}}>
                  <tr><th>Hp Order No</th><th>Customer Name</th><th>Last Update Date</th><th>Summarized Status</th><th>Action</th></tr>
                  {
                    this.state.notificationData.map((nt, i) => {
                      const lon = nt.legacy_order_no;
                      return (<tr key={i}><td><span className="widgetLink" onClick={() => this.handleOrderLink(lon)}>{nt.order_no}</span></td><td>{nt.customer_name}</td><td>{nt.last_update.substr(0, 10)}</td><td>{nt.order_overall_status}</td><td><span onClick={() => this.handleUnSubscribe(lon)} style={{ "color": "#00AA00"}}><SubscribeIcon /></span></td></tr>)
                    })
                  }
                </table>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-info" onClick={this.handleNotificationModel}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    var editNews = null;
    if (UserSettings && UserSettings.memberOf && UserSettings.memberOf("SMEUser")) {
       editNews = <button type="button" className="btn btn-danger" data-toggle="collapse" data-target="#news-panel" onClick={() => {window.CloseNews; window.open('/os/landing.tcl?editnewsint=1', '_blank');}}>Edit</button>
    }
    
    var scriptCode = "console.log('initJOLO'); InitOSSMenu();"

    var fedStr = '';
    var fedSwitch = [];
    var tmpSwitch = null;
    var hpeTheme1 = {};
    var hpeThemeCSS = null;

    var adhocUrl   = "/os/os.tcl?getrep=1&amp;adhoc=1&amp;dontvalidate=1"
    var brandClass = "navbar-brand dropdown"
    var repQueueUrl = "/os/support/ReportQueue"
    var e2eTrackUrl = "/os/E2eTracking.tcl"
    var supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    var trainingUrl = "/docs/index.html"
    var dictionaryUrl = "http://hpi12.sharepoint.hp.com/teams/TeamRecordings/Order%20to%20Cash/OSS/OSS%20Data%20Dictionary/index.htm"

    var newDataDictUrl   = "/static/dist/dataDictionary.html"
    var newDictionaryUrl = 'https://hp.sharepoint.com/teams/pcbits/bitshomepage/SitePages/OSS%20General%20Training.aspx'
   if (tenant == "HPI") {
      adhocUrl = "/os/ios.tcl?getrep=1&adhoc=1&dontvalidate=1"
      brandClass = "navbar-brand dropdown hpi"
      fedStr = 'HPI'
      if (UserSettings.memberOf('FedUser') && UserSettings.memberOf('HPIUser') && UserSettings.isValidAcv('AMS','100')) {
        fedSwitch.push(<li key="switch-fed"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPIFEDLLC}>Switch to FEDLLC view</a></li>)
        if (UserSettings.memberOf('HPICSUser'))
          fedSwitch.push(<li key="switch-cs"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPICS}>Switch to HPICS view</a></li>)
        if (UserSettings.memberOf('HPStoreUser'))
          fedSwitch.push(<li key="switch-hps"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPSTORE}>Switch to HP STORE view</a></li>)
      }
      else if (UserSettings.memberOf('HPIUser')) {
        if (UserSettings.memberOf('HPICSUser'))
          fedSwitch.push(<li key="switch-cs"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPICS}>Switch to HPICS view</a></li>)
        if (UserSettings.memberOf('HPStoreUser'))
            fedSwitch.push(<li key="switch-hps"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPSTORE}>Switch to HP STORE view</a></li>)
      }
      else if(UserSettings.memberOf('HPStoreUser')) {
        SwitchToHPSTORE()
      }

      supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    }
    if (tenant == "HPIFEDLLC") {
      adhocUrl = "/os/fos.tcl?getrep=1&adhoc=1&dontvalidate=1"
      brandClass = "navbar-brand dropdown hpi"
      fedStr = 'FED'
      fedSwitch = <li key="switch-hpi"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPI}>Switch to HP Inc view</a></li>
      supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    }
    if (tenant == "HPSTORE") {
      adhocUrl = "/os/sos.tcl?getrep=1&adhoc=1&dontvalidate=1"
      brandClass = "navbar-brand dropdown hpi"
      fedStr = 'HP STORE'
      if (UserSettings.memberOf('HPIUser')) {
        fedSwitch = <li key="switch-hpi"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPI}>Switch to HP Inc view</a></li>
      }
      supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    }
    if (tenant == "HPICS") {
      adhocUrl = "/os/csos.tcl?getrep=1&adhoc=1&dontvalidate=1"
      brandClass = "navbar-brand dropdown hpi"
      fedStr = 'HPICS'
      if (UserSettings.memberOf('HPIUser')) {
        fedSwitch = <li key="switch-hpi"><a style={{ "cursor": "pointer"}} onClick={window.SwitchToHPI}>Switch to HP Inc view</a></li>
      }
      supportUrl = "https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr"
    }
    if (tenant == "HPE") {
      adhocUrl = "/os/eos.tcl?getrep=1&adhoc=1&dontvalidate=1"
      brandClass = "navbar-brand dropdown hpe"
      trainingUrl = "http://ent141.sharepoint.hp.com/teams/pcbits/bitshomepage/SitePages/OSS.aspx"
      dictionaryUrl = "http://ent141.sharepoint.hp.com/teams/pcbits/bitshomepage/Robohelp%20Document%20Library/OSS/OSS%20Data%20Dictionary/index.htm"
      supportUrl = "http://intranet.hp.com/gtbp/so/bus/Documents/hpe/window/GUS/oss.html"
      hpeTheme1 = { 'borderBottom': '1px solid #00B388' }

      hpeThemeCSS = <style dangerouslySetInnerHTML={ {__html: ".navbar-default .navbar-nav .active a { color: #555; backgroundColor: transparent; borderBottom: 3px solid #00B388; }" }}>
                     </style>
    }

    var LayerLabel = <b style={{ color: "#c1401a"}}>{LayerName}</b>

    var BacklogTab = '';
    var ReportTab  = '';
    var NewReportTab = '';
    var OldReportTab = '';
    var CreateTab = '';
    var TemplatesTab = '';
    var SubscriptionTab = '';
    // var isImpersonated = typeof document !== 'undefined' && /(?:^|;\s*)(?:osuiImpersonate|portalImpersonate|ossImpersonated)=/.test(document.cookie);
    // var canAccessReporting = !UserSettings.memberOf('CS_ExternalAccess') || UserSettings.memberOf('CSExtAreaReporting');
    var OSSProdTab = '';
    var ToolsTab   = '';
    var RepQueue   = '';
    var ImpLink    = '';
    var E2eLink    = '';
    var CustomerContractTab = '';
    var HelpTabAdditional = '';

    var InventoryTool = ''
    var OrderWorkflowTool = '';

    const newReportTabStyle = {
      display: 'inline-block',
      width: '20px',
      height: '20px',
      lineHeight: '20px',
      fontSize: '11px',
      textAlign: 'center',
      borderRadius: '50%',
      color: 'white',
      marginLeft: '5px'
    };

    const redBox = {
      ...newReportTabStyle,
      backgroundColor: 'red'
    };

    const greenBox = {
      ...newReportTabStyle,
      backgroundColor: 'green'
    };

    //console.log("LayerName: "+ LayerName)

    if (!window.location.href.includes("report".toLowerCase()) && tenant == "HPICS" && UserSettings.memberOf('InventoryTool') && (!UserSettings.memberOf('CS_ExternalAccess') || UserSettings.memberOf('CSExtAreaInventory')) ) {
      InventoryTool = <li><a className="noHighlight" target="_blank" href="/static/dist/inventoryTool.html">Inventory Tool</a></li>
    }
    if (!window.location.href.includes("report".toLowerCase()) && tenant == "HPI" && UserSettings.memberOf('MaintenanceOrderWorkflow')) {
      OrderWorkflowTool = <li><a className="noHighlight" target="_blank" href="/os/admin/SetOrderWorkflowStatus.tcl">Order Workflow Maintenance</a></li>
    }
    if (!window.location.href.includes("report".toLowerCase()) && isHpUser(UserSettings.user_id) ) {
      HelpTabAdditional = <>
                            <li key="help-divider-1" className="divider"></li>
                            <li key="help-data-dict"><a className="noHighlight" target="_blank" href={newDataDictUrl}><i className="fa-solid fa-book" fill="currentcolor" stroke="currentcolor" style={{fontSize: "18px", color: "unset", marginRight: "11px", marginLeft: "4px"}}></i>OSS Data Dictionary</a></li>
                          </>
    }

    if ( !UserSettings.memberOf('CS_ExternalAccess') || UserSettings.memberOf('CSExtAreaReporting') ) {
      ReportTab = <li key="reports"  className={active == 'report' ? "active": ""}><a target="_blank" href={adhocUrl}>Report</a></li>
      OldReportTab = <li key="reports"  className={active == 'report' ? "active": ""}><a target="_blank" href={adhocUrl}>Old Report</a></li>
      if (UserSettings.memberOf('Q2C_OSS_NEW_REP_PILOT_USERS')) {
        const pathName = window.location.pathname || '';
        const isBuilder = pathName.endsWith('/reportBuilder.html');
        const isLanding = pathName.endsWith('/reporting.html');
        const isNewReportActive = isLanding;
        NewReportTab = <li key="newreports" className={isNewReportActive ? "active" : ""}><a href="/static/dist/reporting.html" target="_blank">My Reports<span style={{color: 'red', position: 'absolute', bottom: '-5px', right: '4px', fontSize: '10px'}}>pilot</span></a></li>
        CreateTab = <li key="createreport" className={isBuilder ? "active" : ""}><a href="/static/dist/reportBuilder.html" target="_blank">Create</a></li>
        SubscriptionTab = <li key="subscriptions" className={active == 'subscription' ? "active": ""}><a target="_blank" href="/static/dist/reportSubscription.html">Subscription</a></li>
        TemplatesTab = <li key="templates" className={active == 'templates' ? "active": ""}><a target="_blank" href="/static/dist/reportTemplates.html">Templates</a></li>
      }
    }
    if ( LayerName == "ARCH" ) {
      RepQueue   = <li key="help-reportqueue"><a className="noHighlight" target="_blank" href={repQueueUrl}>Report Queue</a></li>
      E2eLink    = <li key="help-e2e-link"><a className="noHighlight" target="_blank" href={e2eTrackUrl}>End-2-End Tracking</a></li>
      ImpLink    = <li key="help-cust-portals-osv"><a className="noHighlight" target="_blank" href="/os/ILogin.tcl">Impersonate User</a></li>
      OSSProdTab = <li key="oss-prod-tab"><a className={active == 'ossprod' ? "active": ""} target="_blank" href={"https://oss.hpcloud.hp.com/os/landing?forcedTenant="+tenant}>OSS Prod</a></li>
    } else {
      if ( !UserSettings.memberOf('CS_ExternalAccess') || UserSettings.memberOf('CSExtAreaBMT') ) {
        BacklogTab = <li key="backlog" className={active == 'backlog' ? "active": ""}><a target="_blank" href="/static/dist/bmt.html">Backlog</a></li>
      }
      CustomerContractTab = <li key="customercontract" className={active == 'customercontract' ? "active": ""}><a target="_blank" href="/os/CMasterSearch">Customer & Contract</a></li>

      ToolsTab   = 
              <li key="tools" className={active == 'tools' ? "active dropdown" : "dropdown"}>
                <a href="#" className="dropdown-toggle" data-toggle="dropdown">Tools&nbsp;<b className="caret"></b></a>
                <ul className="dropdown-menu">
                  
                  {InventoryTool}
                  <li key="cust-portals-osv"><a className="noHighlight" target="_blank" href="/os/ILogin.tcl">Customer Impersonation</a></li>
                  <li key="osslayers-arch"><a className="noHighlight" target="_blank" href={"https://oss-arch.hpcloud.hp.com/os/landing?forcedTenant="+tenant}>Archive</a></li>
                  <li key="moretools-mass-dnld"><a className="noHighlight" target="_blank" href="/static/dist/massDL.html">Mass download (Hist. Data)</a></li>
                  <li key="moretools-adb"><a className="noHighlight" target="_blank" href="https://app.powerbi.com/groups/me/dashboards/bef4548c-9611-4da7-a432-01cf1b6a85db?ctid=ca7981a2-785a-463d-b82a-3db87dfc3ce6">Data Quality</a></li>
                  
                  <li key="moretools" className="dropdown-submenu">
                    <a className="noHighlight" tabIndex="-1" href="#">OSS SME Tools</a>
                    <ul className="dropdown-menu">
                      {OrderWorkflowTool}
                      <li key="outbound" className="dropdown-submenu">
                        <a className="noHighlight" tabIndex="-1" href="#">Outbound</a>
                        <ul className="dropdown-menu">
                          <li key="outbound-setup" ><a className="noHighlight" target="_blank" href="/os/OutboundSetup?search=">Outbound Setup</a></li>
                          <li key="outbound-layout"><a className="noHighlight" target="_blank" href="/os/OutboundLayout?search=">Outbound Layout</a></li>
                          <li key="outbound-e2e"   ><a className="noHighlight" target="_blank" href="/os/E2eTracking.tcl">End-2-End Tracking</a></li>
                          <li key="outbound-msg"   ><a className="noHighlight" target="_blank" href="/os/MessageViewer">Message Viewer</a></li>
                          <li key="outbound-audit" ><a className="noHighlight" target="_blank" href="/os/Audit">Audit Log</a></li>
                        </ul>
                      </li>
                      <li key="bmtadmin" className="dropdown-submenu">
                        <a className="noHighlight" tabIndex="-1" href="#">BMT Admin</a>
                        <ul className="dropdown-menu">
                          <li key="bmtadmin-profile"><a className="noHighlight" target="_blank" href="/static/dist/profileEditor.html">My Order Profile Maintenance</a></li>
                          <li key="bmtadmin-dashboard"><a className="noHighlight" target="_blank" href="/static/dist/alertMaint.html">Dashboard Maintenance</a></li>
                          <li key="bmtadmin-alert"><a className="noHighlight" target="_blank" href="/static/dist/alertEdit.html">Alert Maintenance</a></li>
                          <li key="bmtadmin-drillDown"><a className="noHighlight" target="_blank" href="/static/dist/drillDownTemplate.html">Drill Down Maintenance</a></li>
                          <li key="bmtadmin-divider-2" className="divider"></li>
                          <li key="bmtadmin-cdf"><a className="noHighlight" target="_blank" href="/os/admin/ManualCDFUpload">CDF Upload</a></li>
                          <li key="bmtadmin-divider-3" className="divider"></li>
                          <li key="bmtadmin-manual-ack"><a className="noHighlight" target="_blank" href="/os/admin/ManualAckUpload">Manual Ack Upload</a></li>
                          <li key="bmtadmin-manual-date"><a className="noHighlight" target="_blank" href="/os/admin/ManualPlannedDatesUpload?mode=upload">Manual Planned Ship And Delivery Dates Upload</a></li>
                          <li key="bmtadmin-divider-4" className="divider"></li>
                          <li key="bmtadmin-rdf"><a className="noHighlight" target="_blank" href="/os/admin/RevenueDelayFactorUpload">Revenue Delay Factor Maintenance</a></li>
                        </ul>
                      </li>
                      <li key="osslayers" className="dropdown-submenu">
                        <a className="noHighlight" tabIndex="-1" href="#">OSS Layers</a>
                        <ul className="dropdown-menu">
                          <li key="osslayers-pro"><a href="https://oss.hpcloud.hp.com/">PRO</a></li>
                          <li key="osslayers-qa"><a href="https://oss-qa.hpcloud.hp.com/">QA</a></li>
                          <li key="osslayers-stg"><a href="https://oss-stg.hpcloud.hp.com/">STG</a></li>
                          <li key="osslayers-itg"><a href="https://oss-itg.hpcloud.hp.com/">ITG</a></li>
                        </ul>
                      </li>
                      <li key="account-contact" className="dropdown-submenu">
                        <a className="noHighlight" tabIndex="-1" href="#">Account Contact</a>
                        <ul className="dropdown-menu">
                          <li key="account-contact-viewer"><a className="noHighlight" target="_blank" href="/static/dist/acctContactViewer.html">Account Contact Viewer</a></li>
                          <li key="account-contact-maint"><a className="noHighlight" target="_blank" href="/static/dist/dataMaintTool.html?view=acct_contact">Account Contact Maintenance</a></li>
                        </ul>
                      </li>
                      <li key="moretools-e2e-tracking"><a className="noHighlight" target="_blank" href="/os/E2eTracking.tcl">End-2-End Tracking</a></li>
                      <li key="moretools-correlation"><a className="noHighlight" target="_blank" href="/os/correlation.tcl">Q2C Correlation</a></li>
                      <li key="moretools-divider-2" className="divider"></li>
                      <li key="help-wiki"><a className="noHighlight" target="_blank" href={_wikiUrl}>OSS Wiki</a></li>
                      <li key="help-divider-2" className="divider"></li>
                      <li key="moretools-admin"><a className="noHighlight" target="_blank" href="/os/admin/admin.tcl">Admin Page</a></li>
                      <li key="moretools-support"><a className="noHighlight" target="_blank" href="/index.tcl?oss_support">Support Page</a></li>
                      {(LayerName === 'DEV' || LayerName === 'ITG') && UserSettings.memberOf('LogViewer') && (
                        <li key="ossregression" className="dropdown-submenu">
                          <a className="noHighlight" tabIndex="-1" href="#">OSS Regression Testing</a>
                          <ul className="dropdown-menu">
                            <li key="ossregression-rt"><a href="/static/dist/qaRegression.html">RT Script Execution</a></li>
                          </ul>
                        </li>
                      )}
                    </ul>
                  </li>
                </ul>
              </li>
    }

    return (

      <nav className="navbar navbar-default" role="navigation">
        <div className="container-fluid">
          <div className="navbar-header">
            <a className={brandClass} style={{"marginLeft": "-5px"}}
               href="#"
               data-toggle="dropdown" > <span id="tmb-page-title" style={{fontWeight: "700", color: '#0096d6', marginRight: "10px"}}>{this.props.heading || 'OrderStatus'}</span><b>{fedStr}</b>&nbsp;&nbsp;{LayerLabel}
            </a>
                <ul className="dropdown-menu" style={{"marginTop": "-0px"}} >
                  {fedSwitch}
                  {tmpSwitch}
                </ul>

          </div>

          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1" style={{ paddingRight: "0px" }} >
            <ul className="nav navbar-nav">

              {window.location.href.includes("report".toLowerCase()) && NewReportTab}
              {window.location.href.includes("report".toLowerCase()) && TemplatesTab}
              {window.location.href.includes("report".toLowerCase()) && CreateTab}
              {window.location.href.includes("report".toLowerCase()) && SubscriptionTab}
              {window.location.href.includes("report".toLowerCase()) && OldReportTab}
              {window.location.href.includes("report".toLowerCase()) && <li key="help-tab" className={active == 'help' ? "active": ""}><a href="">Help</a></li>}
              {!window.location.href.includes("report".toLowerCase()) && <li key="home" className={active == 'home' ? "active": ""}><a href="/os/landing">Home</a></li>}
              {window.location.href.includes("report".toLowerCase()) && <li key="home" className={active == 'home' ? "active": ""}><a href="/os/landing">OSS Home</a></li>}
              {!window.location.href.includes("report".toLowerCase()) && BacklogTab}


              {!window.location.href.includes("report".toLowerCase()) && ReportTab}
              {!window.location.href.includes("report".toLowerCase()) && NewReportTab}

              {OSSProdTab}
              { !window.location.href.includes("report".toLowerCase()) && isHpUser(UserSettings.user_id) && CustomerContractTab}
              { false && UserSettings.memberOf('SupportRequests') && <li><a key="my-support-request" href={this.state.supportRequestUrl} target='_blank'>My Support Requests</a></li>}
              {!window.location.href.includes("reporting") && UserSettings.memberOf('SupportRequests') && <li><a key="my-support-request" href={this.state.supportRequestUrl} target='_blank'>My Support Requests</a></li>}

              {!window.location.href.includes("report".toLowerCase()) && isHpUser(UserSettings.user_id) ? ToolsTab : InventoryTool }

              <li key="help-dropdown" className={active == 'help' ? "active dropdown" : "dropdown"}>
                {!window.location.href.includes("report".toLowerCase()) && <a href="#" className="dropdown-toggle" data-toggle="dropdown">Help&nbsp;<b className="caret"></b></a>}
                <ul className="dropdown-menu">
                  <li key="help-show-news">
                    <a data-toggle="collapse" href="#news-panel">
                      <i className="fa-solid fa-newspaper" fill="currentcolor" stroke="currentcolor" style={{fontSize: "18px", color: "unset", marginRight: "10px"}}></i>
                      Show News
                    </a>
                  </li>
                  <li key="help-ai-chatbot">
                    <a title="Sandy" onClick={() => window.toggleChatbot()} style={{'cursor':'pointer'}}>
                      <i className="fa-solid fa-oss-sandy" fill="currentcolor" stroke="currentcolor" style={{fontSize: "18px", color: "unset", marginRight: "10px"}}></i>
                      Sandy
                    </a>
                  </li>
                  { isHpUser(UserSettings.user_id) && <li key="help-rel-notes"><a onClick={window.OpenRelNotes}><i className="fa-solid fa-file-lines" fill="currentcolor" stroke="currentcolor" style={{fontSize: "18px", color: "unset", marginRight: "11px", marginLeft: "4px"}}></i>Release Notes</a></li> }
                  { isHpUser(UserSettings.user_id) && <li key="help-training"><a className="noHighlight" target="_blank" href={trainingUrl}><i className="fa-solid fa-book-open-reader" fill="currentcolor" stroke="currentcolor" style={{fontSize: "18px", color: "unset", marginRight: "10px"}}></i>Training & Documentation</a></li> }
                  <li key="help-support"><a className="noHighlight" target="_blank" href={supportUrl}><i className="fa-solid fa-person-circle-question" fill="currentcolor" stroke="currentcolor" style={{fontSize: "18px", color: "unset", marginRight: "10px"}}></i>Need Support</a></li>
                  { isHpUser(UserSettings.user_id) && RepQueue}
                  {HelpTabAdditional}
                </ul>
              </li>

            </ul>
            <ul className="searchSettingNewRespUI nav navbar-nav navbar-right" style={{ "marginRight": "-10px"}}>
              <li>
                <a title="Sandy" onClick={() => window.toggleChatbot()} style={{'padding': '0px', 'border': 'none', 'cursor': 'pointer'}}>
                  <i className="fa-solid fa-oss-sandy" fill="currentcolor" stroke="currentcolor" style={{fontSize: "22px", color: "unset", marginRight: "5px", paddingTop: "3px"}}></i>
                </a>
              </li>
              <li>
                <a title="Quick Search" data-toggle="collapse" href="#qs-panel" style={{'padding': '0px', 'border': 'none'}}>
                  <i className="fa-solid fa-magnifying-glass" fill="currentcolor" stroke="currentcolor" style={{fontSize: "22px", color: "unset", marginRight: "5px", paddingTop: "3px"}}></i>
                </a>
              </li>
              <li>
                <a title="Show News" data-toggle="collapse" href="#news-panel" style={{ 'padding': "0px" , 'border': 'none'}}>
                  <i className="fa-solid fa-newspaper" fill="currentcolor" stroke="currentcolor" style={{fontSize: "22px", color: "unset", marginRight: "5px", paddingTop: "3px"}}></i>
                </a>
              </li>
              <li className='notifications'>
                <a href='#' style={{padding: "3px 0px 0px 0px", border: "none", marginRight: "5px"}}><NotificationIcon /></a>
                {notificationDetails}
                {notificationModel}
              </li>
              <li key="options" className="dropdown" >
                <a href="#" className="dropdown-toggle" data-toggle="dropdown" style={{ "padding": "0px"}} >
                  <i className="fa-solid fa-user" fill="currentcolor" stroke="currentcolor" style={{fontSize: "20px", color: "unset", marginRight: "5px", padding: "3px 0px 0px 3px"}}></i>
                </a>
                <ul className="dropdown-menu">
                  <li key="options-user"><div style={{ "padding" : "10px",
                                    "backgroundColor": "#f4f4f4",
                                    "fontSize": "13px"
                                 }}
                       >user:<br/>{user_id}</div>
                  </li>
                  <li key="options-profile" style={{ "padding" : "10px", "fontSize": "13px","whiteSpace": "nowrap"}}>
                      OSS Profiles:
                  </li>
                  {this.state.displayGroupData}
                  <li className="divider"></li>
                  {downloadSettings}
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div id="internalWidget"></div>
        <div id="notesbody" />

        <div id="qs-panel" className="collapse qs-panel" style={{"marginTop": "-2px"}}>
          <form className="navbar-form navbar-left" role="search" style={{"padding": "0px"}} >
            <div className="form-group">
              <div id="fastsearch_container">
                <input type="text" className="form-control" id="quicksearch" onPaste={(e) => window.handlePaste(e)}
                       title="Enter a reference (PO#, HPOrder#, SAPOrder#, Shipment# or PackId, Invoice#, WebOrder#, Deal#, AccountName, Serial#, Quote#, BOL#)"
                       placeholder="Enter a reference (PO#, HPOrder#, SAPOrder#, Shipment# or PackId, Invoice#, WebOrder#, Deal#, AccountName, Serial#, Quote#, BOL#)" />
                 <span id='fastsearch_x_top' data-toggle="collapse" href="#qs-panel" onClick={this.handleClearInput}>X</span>
              </div>
            </div>
          </form>
        </div>

        <div id="news-panel" className='collapse news-panel' style={{"marginTop":"0px"}}>
          <div className="news-panel-hdr">
            Welcome to Order Status Suite (OSS)
            <div className="news-panel-hdr-st">
              News Update
            </div>
          </div>
          <div className="news-panel-body" dangerouslySetInnerHTML={{__html: newsSection}} />
          <div className="news-panel-ftr">
            <button type="button" className="btn btn-primary" onClick={window.CloseNews} data-toggle="collapse" data-target="#news-panel">Close</button>
            &nbsp;
            {editNews}
          </div>
        </div>

        <div id="toast-popup-container" className="toast-popup-container" style={{"display": "none"}}>
          <div id="toast-popup-close" className="toast-popup-close" onClick={(e)=>{e.target.parentNode.style.display = 'none'}}>X</div>
          <div id="toast-popup-msg" className="toast-popup-msg"></div>
          <div id="toast-popup-bar" className="toast-popup-bar"></div>
        </div>

        <script type="text/javascript" dangerouslySetInnerHTML={{__html: scriptCode}} />
        <script src="/os/js/topMenuBar.js"></script>

        <Chatbot />

        {
          UserSettings && UserSettings.config?.maintMsg
          ? <MaintMsgModal msg={UserSettings.config.maintMsg} />
          : null
        }
      </nav>
    )
  }

};

//----------------------------------------------------------------------------
//  main HTML fragements (head+body with standard includes)
//
//----------------------------------------------------------------------------
export class QTCPage extends React.Component {

  render() {

    //GEGA REWORK THIS COMPLETELY
    var title = this.props.title ? this.props.title : "OSS";

    return (
      <html lang="en">
        <head>
         <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
         <meta charSet="utf-8"/>
         <title>{title}</title>

         <meta name="viewport" content="width=device-width, initial-scale=1.0"/>

         <script type="text/javascript" src="/static/common/ssr/tenantSwitch.js"></script>
         <script type="text/javascript" src="/static/dist/vendor.SSR.bundle.js"></script>
         <script type="text/javascript" src="/static/dist/intBundle.SSR.bundle.js"></script>

       </head>
       <body>{this.props.children}</body>

      </html>
    )
  }

};
